export enum ViewMode {
  grid = 'grid', ribbon = 'ribbon', teacherOnly = 'teacherOnly', pictureInPicture = 'pictureInPicture'
}
